import { Button, Divider, Typography } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";

import { DATASET_TYPES } from "@/constants/DatasetTypes";
import { useUpdate } from "@/hooks/queries";
import { useApiErrorHandler } from "@/modules/api-errors";
import { useSidePanel } from "@/modules/side-panel";

import { TreeModifier } from "./TreeModifier";

const RemoveSectionConfirmation = ({ template, layoutIndex }) => {
  const { t } = useTranslation();
  const [_, setSearchParams] = useSearchParams();
  const { closeSidePanel } = useSidePanel();
  const { onError } = useApiErrorHandler();

  const mutation = useUpdate("interventionTemplates", template.id);

  const section = TreeModifier.find(
    template,
    "templates",
    (template) => template.layout_index === layoutIndex
  );

  const parentSection = TreeModifier.findParentNode(
    template,
    "templates",
    (template) => template.layout_index === layoutIndex
  );

  const isTemplateSubSection = !DATASET_TYPES.includes(section?.type);

  function onRemove() {
    const updatedTree = TreeModifier.findAndRemove(
      template,
      "templates",
      (template) => template.layout_index === layoutIndex
    );
    mutation.mutate(
      { templates: updatedTree.templates },
      {
        onSuccess: function () {
          if (isTemplateSubSection) {
            // Redirect to parent section
            setSearchParams({ layout_index: parentSection.layout_index });
          }
          onClose();
        },
        onError,
      }
    );
  }

  function onClose() {
    closeSidePanel();
  }

  return (
    <>
      <Typography.Text>{section?.name}</Typography.Text>
      <Divider />
      <Button onClick={onClose}>{t("global:cancel")}</Button>
      <Button onClick={onRemove} loading={mutation.isPending} type="primary">
        {t("global:remove")}
      </Button>
    </>
  );
};

RemoveSectionConfirmation.propTypes = {
  template: PropTypes.object.isRequired,
  layoutIndex: PropTypes.number.isRequired,
};

export default RemoveSectionConfirmation;
